import { Callout } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import buttonStyles from '../../components/Button/button.scss'
import { CardContainer } from '../../components/Card'
import BasicLayout from '../../layouts/BasicLayout'
import { RootState } from '../../store'
import { getCarrierType, getPaymentType } from '../../utils'
import styles from './order-page.scss'

const cx = classnames.bind({ ...buttonStyles, ...styles })

interface IProps
  extends RouteComponentProps<any>,
    ReturnType<typeof mapState> {}

class OrderPage extends React.Component<IProps> {
  public state = {
    error: null,
    loading: false
  }
  private ecpayment: HTMLDivElement | null
  public handlePayment = () => {
    const { match } = this.props
    const orderId: string = match.params.orderId
    const createPayment = firebase
      .functions()
      .httpsCallable('payment-createPayment')
    this.setState({ loading: true })
    createPayment({ orderId })
      .then(res => {
        if (this.ecpayment) {
          this.ecpayment.innerHTML = res.data
          const form = window.document.getElementById(
            '_form_aiochk'
          ) as HTMLFormElement
          if (form) {
            form.submit()
          }
        }
      })
      .catch(error => this.setState({ error, loading: false }))
  }
  public handleCancel = () => {
    this.props.history.goBack()
  }
  public render() {
    const { error, loading } = this.state
    const { match, orders } = this.props
    const orderId: string = match.params.orderId
    const order = orders[orderId]
    if (order === undefined) {
      return 'Loading...'
    }
    return (
      <BasicLayout className={cx('Order-main')}>
        <div ref={ref => (this.ecpayment = ref)} />
        <div className={cx('Order-container')}>
          <CardContainer className={cx('page-Order__main')}>
            <h3 className={cx('page-Order__title')}>結帳確認</h3>
            <div className={cx('Ordercard')}>
              <div className={cx('Orderbody')}>
                <div className={cx('Ordertitle')}>結帳總額</div>
                {order.invoice.InvoiceItemName.split('|').map(
                  (itemName, idx) => {
                    const prices = order.invoice.InvoiceItemPrice.split('|')
                    return (
                      <div key={idx} className={cx('OrderItem')}>
                        <div className={cx('pricetitle')}>{itemName}</div>
                        <div className={cx('price')}>NT$ {prices[idx]}</div>
                      </div>
                    )
                  }
                )}
              </div>
            </div>
            <div className={cx('Ordercard')}>
              <div className={cx('Orderbody')}>
                <div className={cx('Ordertitle')}>付款方式</div>
                <div className={cx('OrderItem')}>
                  <div className={cx('OrderSubtitle')}>
                    {getPaymentType(order.paymentType)}
                  </div>
                </div>
              </div>
            </div>

            <div className={cx('Ordercard')}>
              <div className={cx('Orderbody')}>
                <div className={cx('Ordertitle')}>發票資訊</div>
                <div className={cx('OrderItem')}>
                  <div className={cx('OrderSubtitle')}>
                    聯絡人：
                    {order.invoice.CustomerName}
                  </div>
                </div>
                <div className={cx('OrderItem')}>
                  <div className={cx('OrderSubtitle')}>
                    電子信箱：
                    {order.invoice.CustomerEmail}
                  </div>
                </div>
                <div className={cx('OrderItem')}>
                  <div className={cx('OrderSubtitle')}>
                    電子發票 - {getCarrierType(order.invoice.CarruerType)}
                  </div>
                </div>
              </div>
            </div>

            {error ? (
              <Callout intent="danger">{(error as Error).message}</Callout>
            ) : null}

            <div className={cx('OrderBtn')}>
              {loading ? (
                <a
                  className={cx(
                    'btn',
                    'btn--primary',
                    'btn--lg',
                    'btn--disabled'
                  )}
                  onClick={this.handlePayment}
                >
                  處理中，請稍候
                </a>
              ) : (
                <a
                  id="payment-btn"
                  className={cx('btn', 'btn--primary', 'btn--lg')}
                  onClick={this.handlePayment}
                >
                  前往購買
                </a>
              )}
              <a
                id="payment-cancel-btn"
                className={cx('btn', 'btn--primary', 'btn--line', 'btn--lg')}
                onClick={this.handleCancel}
              >
                取消購買
              </a>
            </div>
          </CardContainer>
        </div>
      </BasicLayout>
    )
  }
}

const mapState = ({ auth, orders }: RootState) => ({
  auth,
  orders
})

export default connect(mapState)(OrderPage)



// WEBPACK FOOTER //
// ./src/pages/OrderPage/index.tsx